<template>
  <div class="progress-container">
    <img class="vote-icon" :src="require('../../assets/imgs/vote/A.png')" alt="">
    <div class="progress-box">
      <div class="progress-item" :style="percent > 0 ? `width:${percent}%;` : 'display: none;'">
        <label class="progress-num agree">{{encrypt ? '？' : percent}}%</label>
        <div class="progress-line agree"></div>
      </div>
      <div class="progress-item" :style="percent < 100 ? `width:${100 - percent}%;` : 'display: none;'">
        <label class="progress-num disagree">{{encrypt ? '？' : 100 - percent}}%</label>
        <div class="progress-line disagree"></div>
      </div>
    </div>
    <img class="vote-icon" :src="require('../../assets/imgs/vote/B.png')" alt="">
  </div>
</template>

<script>

  export default {
    name: "VoteProgress",
    props: {
      percent: {
        type: Number,
        default: 0
      },
      encrypt: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
      };
    },
  };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .progress-container {
    display flex
    flex-direction row
    align-items center
    justify-content space-between
    width calc(100% - 40px)
    margin-top 20px

    .vote-icon {
      width auto
      height 26px
    }

    .progress-box {
      display flex
      flex-direction row
      align-items center
      justify-content space-between
      width 100%
      margin 0 15px

      .progress-item {
        display flex
        flex-direction column
        align-items center
        justify-content center

        .progress-num {
          font-size 11px
        }

        .progress-num.agree {
          color #33D2F3
        }

        .progress-num.disagree {
          color #008EDC
        }

        .progress-line {
          height 8px
          width 100%
          margin-bottom 11px
        }

        .progress-line.agree {
          background-color #33D2F3
          background: linear-gradient(-50deg, transparent 5px, #33D2F3 0);
        }

        .progress-line.disagree {
          background-color #008EDC
          background: linear-gradient(130deg, transparent 5px, #008EDC 0);
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// app/components/vote/VoteProgress.vue